// extracted by mini-css-extract-plugin
export default {"department-card":"DepartmentCard_department-card__rHJgB","icon-container":"DepartmentCard_icon-container__ObZir","icon":"DepartmentCard_icon__aAmub"};